/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Payment type/method
 */
export type CreatePaymentBodyType = typeof CreatePaymentBodyType[keyof typeof CreatePaymentBodyType];


export const CreatePaymentBodyType = {
  cash: 'cash',
  bank_transfer: 'bank_transfer',
  card: 'card',
  check: 'check',
  paypal: 'paypal',
  coupon: 'coupon',
  other: 'other',
  credit_note: 'credit_note',
  advance: 'advance',
} as const;
